import type {CircularArcIntersectionDefinition2D} from './ArcCircleIntersectionSolver';
import {
    CircleLineSegmentIntersectionSolver,
    type CircleLineSegmentIntersection2D,
    type LineSegmentIntersectionDefinition2D,
} from './CircleLineSegmentIntersectionSolver';

/**
 * 圆弧与有限线段的单个真实交点。
 */
export interface ArcLineSegmentIntersection2D extends CircleLineSegmentIntersection2D {
    /** 交点在圆弧有效域内的局部参数，范围 `[0, 1]`。 */
    arcParameter: number;
}

/**
 * 圆弧与有限线段的真实交点求解器。
 *
 * 该类继承圆与线段求解器：父类负责支撑圆和有限线段的解析求交，
 * 子类只负责把支撑圆交点过滤到圆弧周期域并输出局部参数。
 */
export class ArcLineSegmentIntersectionSolver extends CircleLineSegmentIntersectionSolver {
    /**
     * 求解圆弧与有限线段的全部真实交点。
     *
     * @param arc 圆弧定义。
     * @param lineSegment 有限线段定义。
     * @returns 位于圆弧有效域内的真实交点。
     */
    public solveArcLine(
        arc: CircularArcIntersectionDefinition2D,
        lineSegment: LineSegmentIntersectionDefinition2D,
    ): ArcLineSegmentIntersection2D[] {
        return super.solve(arc, lineSegment).flatMap((intersection) => {
            // 父类已经保证点位于支撑圆和有限线段上，此处只收口圆弧参数域语义。
            const arcParameter = this.projectAngleToDomainParameter(intersection.circleAngle, arc);
            return arcParameter === null
                ? []
                : [{...intersection, arcParameter}];
        });
    }
}
